<nz-collapse>
    <nz-collapse-panel appCollapseKeyboard [nzHeader]="header" [nzActive]="expanded" (nzActiveChange)="onActiveChange($event)">
        <ng-content></ng-content>
    </nz-collapse-panel>
</nz-collapse>
